<template>
    <div class="wrapper">
        <div class="row">
            <div class="col-12">
                <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                        <th>Naam</th>
                        <th>Bedrijf</th>
                        <th>Oppervlakte</th>
                        <th>Geïnstalleerd vermogen (&#181;mol/m<sup>2</sup>s)</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                      <td><a href="javascript:void(0)" @click="naarTeelten(item.id, item.bedrijf.id)" title="Naar teelten">{{item.naam}}</a></td>
                        <td>{{item.bedrijf.naam}}</td>
                        <td>{{item.oppervlakte}} m<sup>2</sup></td>
                        <td>{{belichtingen(item)}}</td>
                        <td nowrap>
                            <a href="javascript:void(0)" @click="kopieer(item.id)" title="Afdeling kopiëren"><i class="fa fa-copy"></i></a>
                            &nbsp;
                            <router-link :to="'/beheer/afdeling/edit/' + item.id"><i class="fa fa-pencil-square-o" title="Afdeling wijzigen"></i></router-link>
                            &nbsp;
                            <a  title="Afdeling verwijderen" href="javascript:void(0)" @click="bevestigItem(item.id, item.naam)" v-show="item.deleteok"><i class="fa fa-trash"></i></a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <nav>
                    <ul class="pagination">
                        <li class="page-item"><router-link class="page-link" to="/beheer/afdeling/new">Afdeling toevoegen</router-link></li>
                    </ul>
                </nav>
            </div><!--/.col-->
        </div><!--/.row-->

        <b-modal title="Verwijderen" size="sm" v-model="warningModal" @ok="deleteItem">
            Afdeling <b>{{name}}</b> wordt verwijderd. Bent u zeker?
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'List',
        props: ['items'],
        data () {
            return {
                id: -1,
                name: '',
                warningModal: false,
            };
        },
        methods: {
            belichtingen (item) {
                let resultaat = '';
                item.belichting_n.forEach((belichting) => {
                    resultaat += `${belichting.fotonflux} | `;
                    // resultaat += `${((belichting.efficientie * belichting.aantalLampen
                    // * belichting.opgenomenVermogenPerLamp) /
                    // item.oppervlakte).toLocaleString('de-DE')} | `;
                });
                return resultaat.substring(0, resultaat.length - 3);
            },
            naarTeelten (afdelingid, bedrijfid) {
                this.$store.dispatch('setAfdelingAfdelingteeltFilter', { afdelingid, bedrijfid });
                this.$router.push('/beheer/afdelingteelt');
            },
            bevestigItem (id, name) {
                this.id = id;
                this.name = name;
                this.warningModal = true;
            },
            deleteItem () {
                this.warningModal = false;
                this.$emit('delete-item', this.id);
            },
            kopieer (id) {
                this.$emit('kopieer-item', id);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/afdeling/List.vue